var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellentemoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C24.866 17.134 24.866 10.866 21 7C17.134 3.13401 10.866 3.13401 7 7C3.13401 10.866 3.13401 17.134 7 21C10.866 24.866 17.134 24.866 21 21Z",
    fill: "#FFD05D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1807 5.55469C20.1665 7.09382 20.7382 8.92366 20.7382 10.8871C20.7382 16.3545 16.306 20.7866 10.8386 20.7866C8.93976 20.7866 7.16602 20.2516 5.65918 19.3248C7.41852 22.0715 10.4974 23.892 14.0013 23.892C19.4687 23.892 23.9009 19.4598 23.9009 13.9924C23.901 10.4238 22.0125 7.2966 19.1807 5.55469Z",
    fill: "#FDC453"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4458 15.0451C5.4458 9.96893 9.56088 5.85386 14.637 5.85386C17.6041 5.85386 20.2423 7.26024 21.9228 9.44222C20.3357 6.68696 17.3609 4.83203 13.953 4.83203C8.87679 4.83203 4.76172 8.9471 4.76172 14.0233C4.76172 16.1323 5.47263 18.0752 6.66717 19.6261C5.89028 18.2775 5.4458 16.7131 5.4458 15.0451Z",
    fill: "#FFD77F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0838 11.5947C11.0838 12.2738 10.7572 12.8242 10.3544 12.8242C9.95159 12.8242 9.625 12.2738 9.625 11.5947C9.625 10.9156 9.95159 10.3652 10.3544 10.3652C10.7572 10.3652 11.0838 10.9156 11.0838 11.5947Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3778 11.5947C18.3778 12.2738 18.0512 12.8242 17.6484 12.8242C17.2457 12.8242 16.9189 12.2738 16.9189 11.5947C16.9189 10.9156 17.2455 10.3652 17.6484 10.3652C18.0513 10.3652 18.3778 10.9156 18.3778 11.5947Z",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34961 14.9297C7.72661 18.2703 10.5603 20.8669 14.0017 20.8669C17.4432 20.8669 20.2768 18.2703 20.6538 14.9297H7.34961Z",
    fill: "#695342"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40283 19.0523C10.6018 20.1851 12.2179 20.8809 13.9978 20.8809C15.7009 20.8809 17.2546 20.2443 18.4359 19.1969L18.3744 19.053C13.9072 16.8748 9.46357 19.0227 9.40283 19.0523Z",
    fill: "#F06669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellentemoji);
export default __webpack_public_path__ + "static/media/Excellentemoji.6b51b03fc3218d6ff5701504b91baf07.svg";
export { ForwardRef as ReactComponent };